import { FC } from 'react'
import { Box, DialogContent, DialogActions, Typography, IconButton, DialogTitle } from '@mui/material'

/* Utils */
import { SSMCell, SSMCellProduct } from 'models'

/* Components */
import { Dialog } from './confirmRemovalDialog.styles'
import ThemeButton from '../../../components/buttons/theme/Button'

export interface Props {
  open: boolean
  onClose: () => void
  handleClick: (product: SSMCellProduct) => void
  product?: SSMCellProduct
  cell?: SSMCell
  removing: boolean
  type: 'local' | 'global'
  affectedCells?: Array<{ nist: string; asset: string }>
}

const ConfirmRemovalDialog: FC<Props> = ({
  onClose,
  open,
  handleClick,
  product,
  cell,
  removing,
  type,
  affectedCells
}) => {
  if (!cell || !product) return <></>
  if (type === 'local') {
    return (
      <Dialog onClose={onClose} open={open}>
        <DialogTitle>
          <Box className="header">
            <Typography className="header-title">
              Remove <span className="capitalize">{product.display_name}</span> from{' '}
              <span className="capitalize">
                {cell.nist}/{cell.asset}
              </span>
            </Typography>
            <IconButton size="medium" onClick={onClose}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20 5.61143L18.3886 4L12 10.3886L5.61143 4L4 5.61143L10.3886 12L4 18.3886L5.61143 20L12 13.6114L18.3886 20L20 18.3886L13.6114 12L20 5.61143Z"
                  fill="#D0C3CC"
                />
              </svg>
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography className="content-title">
            Are you sure you want to remove <span>{product.display_name}</span> from{' '}
            <span className="capitalize">
              {cell.nist}/{cell.asset}
            </span>
            ? The product will remain in all other areas where it is currently used
          </Typography>
        </DialogContent>
        <DialogActions>
          <ThemeButton themevariant="secondary" onClick={onClose} disabled={removing}>
            Cancel
          </ThemeButton>
          <ThemeButton themevariant="primary" onClick={() => handleClick(product)} disabled={removing}>
            Remove
          </ThemeButton>
        </DialogActions>
      </Dialog>
    )
  }
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>
        <Box className="header">
          <Typography className="header-title">
            Remove <span className="capitalize">{product.display_name}</span> from Security Stack Map
          </Typography>
          <IconButton size="medium" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M20 5.61143L18.3886 4L12 10.3886L5.61143 4L4 5.61143L10.3886 12L4 18.3886L5.61143 20L12 13.6114L18.3886 20L20 18.3886L13.6114 12L20 5.61143Z"
                fill="#D0C3CC"
              />
            </svg>
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography className="content-title">
          Are you sure you want to remove <span>{product.display_name}</span> from{' '}
          {affectedCells && affectedCells.length > 0 ? (
            <>
              {affectedCells.map((thisCell, index) => (
                <>
                  {index > 0 && index === affectedCells.length - 1 && ' and '}
                  {index > 0 && index < affectedCells.length - 1 && ', '}
                  <span className="capitalize" key={`${thisCell.nist}-${thisCell.asset}`}>
                    {thisCell.nist}/{thisCell.asset}
                  </span>
                </>
              ))}
            </>
          ) : (
            <span className="capitalize">
              {cell.nist}/{cell.asset}
            </span>
          )}
          ? The license details for this product will be lost
        </Typography>
      </DialogContent>
      <DialogActions>
        <ThemeButton themevariant="secondary" onClick={onClose} disabled={removing}>
          Cancel
        </ThemeButton>
        <ThemeButton themevariant="primary" onClick={() => handleClick(product)} disabled={removing}>
          Remove
        </ThemeButton>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmRemovalDialog
